export default __webpack_public_path__ + "static/media/profile_white.b6416b2f.svg";